import {RequiredSticker} from './types'

export const canCreateTask = (requiredStickers: RequiredSticker[]): boolean => {
  const isInvalid = requiredStickers.some(sticker => {
    const hasNoDefaultState =
      !sticker.defaultState ||
      (Array.isArray(sticker.defaultState) && !sticker.defaultState.length)
    const isStickerWithStates = ['string', 'sprint'].includes(
      String(sticker.tag.properties.stickerType)
    )
    const needsDefaultDueToStates =
      isStickerWithStates && sticker.tag.states.order.length > 0
    const mustHaveDefaultValue = !isStickerWithStates || needsDefaultDueToStates

    return (
      sticker.required === 'require' &&
      hasNoDefaultState &&
      mustHaveDefaultValue
    )
  })

  return !isInvalid
}
